import React from "react";

export default function StatusBadge({ isConnected }) {
  return (
    <div className={`status-badge ${isConnected ? "online" : "offline"}`}>
      <div className="status-dot"></div>
      <span className="status-text">{isConnected ? "ONLINE" : "OFFLINE"}</span>
    </div>
  );
}